export const authorData = [
  {
    name: "Erica Armstrong Dunbar",
    books: ["She Came to Slay: The Life and Times of Harriet Tubman"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "ericaarmstrongdunbar.com"
  },
  {
    name: "Kalynn Bayron",
    books: ["Cinderella Is Dead", "This Poison Heart", "This Wicked Fate"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "kalynnbayron.com"
  },
  {
    name: "Alexis Henderson",
    books: ["The Year of the Witching"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "alexishenderson.com"
  },
  {
    name: "Tiffany D. Jackson",
    books: [
      "Monday's Not Coming",
      "Allegedly",
      "Blackout",
      "Grown",
      "Let Me Hear a Rhyme",
      "Whiteout",
      "The Weight of Blood",
      "White Smoke"
    ],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "writeinbk.com"
  },
  {
    name: "Kimberly Jones",
    books: ["I'm Not Dying with You Tonight"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "kimjoneswrites.com"
  },
  {
    name: "Gilly Segal",
    books: ["I'm Not Dying with You Tonight"],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "gillysegal.com"
  },
  {
    name: "Camryn Garrett",
    books: ["Full Disclosure"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "camryngarrett.com"
  },
  {
    name: "Hallie Rubenhold",
    books: [
      "The Five: The Untold Lives of the Women Killed by Jack the Ripper"
    ],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "hallierubenhold.com"
  },
  {
    name: "Silvia Moreno-Garcia",
    books: ["Gods of Jade and Shadow"],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "MX",
        name: "Mexico"
      },
      {
        code: "CA",
        name: "Canada"
      }
    ],
    website: "silviamoreno-garcia.com"
  },
  {
    name: "Cho Nam-Joo",
    books: ["Kim Jiyoung, Born 1982", "Miss Kim Knows and Other Stories"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "KR",
        name: "Korea"
      }
    ],
    website: ""
  },
  {
    name: "Kim Liggett",
    books: ["The Grace Year"],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "kimliggett.com"
  },
  {
    name: "P. Djèlí Clark",
    books: [
      "Ring Shout",
      "A Master of Djinn",
      "The Black God's Drums",
      "A Dead Djinn in Cairo",
      "Out There Screaming: An Anthology of New Black Horror"
    ],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "TT",
        name: "Trinidad and Tobago"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "pdjeliclark.com"
  },
  {
    name: "Alexis Hall",
    books: ["Boyfriend Material"],
    poc: false,
    gender: "male",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "quicunquevult.com",
    image: false
  },
  {
    name: "Brit Bennett",
    books: ["The Vanishing Half"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "britbennett.com"
  },
  {
    name: "Jordan Ifueko",
    books: ["Raybearer", "Redemptor"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "NG",
        name: "Nigeria"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "jordanifueko.com"
  },
  {
    name: "Kiley Reid",
    books: ["Such a Fun Age"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "kileyreid.com"
  },
  {
    name: "Dhonielle Clayton",
    books: ["Blackout", "Whiteout"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "dhonielleclayton.com"
  },
  {
    name: "Nic Stone",
    books: ["Blackout", "Whiteout"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "nicstone.info"
  },
  {
    name: "Angie Thomas",
    books: ["Blackout", "Whiteout"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "angiethomas.com"
  },
  {
    name: "Ashley Woodfolk",
    books: ["Blackout", "Whiteout"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "ashleywoodfolk.com"
  },
  {
    name: "Nicola Yoon",
    books: ["Blackout", "Whiteout"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "JM",
        name: "Jamaica"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "nicolayoon.com"
  },
  {
    name: "Nina Varela",
    books: ["Crier's War", "Iron Heart"],
    poc: false,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "ninavarela.com"
  },
  {
    name: "Justina Ireland",
    books: ["Dread Nation", "Deathless Divide", "Rust in the Root"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "authorjustinaireland.com"
  },
  {
    name: "Faridah Àbíké-Íyímídé",
    books: ["Ace of Spades"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      },
      {
        code: "NG",
        name: "Nigeria"
      }
    ],
    website: "faridahabikeiyimide.com"
  },
  {
    name: "N.K. Jemisin",
    books: [
      "How Long 'til Black Future Month?",
      "The City We Became",
      "The Killing Moon",
      "The World We Make",
      "The Hundred Thousand Kingdoms",
      "Emergency Skin",
      "The Broken Kingdoms",
      "The Kingdom of Gods",
      "The Awakened Kingdom",
      "Shades in Shadow",
      "The Shadowed Sun",
      "The Fifth Season",
      "The Obelisk Gate",
      "The Stone Sky",
      "Out There Screaming: An Anthology of New Black Horror"
    ],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "nkjemisin.com"
  },
  {
    name: "Octavia E. Butler",
    books: [
      "Bloodchild and Other Stories",
      "Kindred",
      "Parable of the Sower",
      "Dawn",
      "Adulthood Rites",
      "Imago",
      "Wild Seed",
      "Mind of My Mind",
      "Clay's Ark",
      "Patternmaster"
    ],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "octaviabutler.com"
  },
  {
    name: "Xiran Jay Zhao",
    books: ["Iron Widow"],
    poc: true,
    gender: "non-binary",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "CN",
        name: "China"
      },
      {
        code: "CA",
        name: "Canada"
      }
    ],
    website: "xiranjayzhao.com"
  },
  {
    name: "Nnedi Okorafor",
    books: [
      "Binti",
      "Binti: Home",
      "Binti: Night Masquerade",
      "Akata Witch",
      "Out There Screaming: An Anthology of New Black Horror"
    ],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "NG",
        name: "Nigeria"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "nnedi.com"
  },
  {
    name: "R.F. Kuang",
    books: [
      "The Poppy War",
      "The Dragon Republic",
      "The Burning God",
      "Babel",
      "Yellowface"
    ],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "CN",
        name: "China"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "rfkuang.com"
  },
  {
    name: "Namina Forna",
    books: ["The Gilded Ones"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "SL",
        name: "Sierra Leone"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "naminaforna.com"
  },
  {
    name: "Rivers Solomon",
    books: ["An Unkindness of Ghosts", "The Deep"],
    poc: true,
    gender: "non-binary",
    lgbt: true,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "rivers-solomon.com"
  },
  {
    name: "Trevor Noah",
    books: ["Born a Crime"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "ZA",
        name: "South Africa"
      }
    ],
    website: "trevornoah.com"
  },
  {
    name: "Talia Hibbert",
    books: ["Get a Life, Chloe Brown"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "taliahibbert.com"
  },
  {
    name: "June Hur",
    books: ["The Red Palace"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "KR",
        name: "Korea"
      },
      {
        code: "CA",
        name: "Canada"
      }
    ],
    website: "junehur.com"
  },
  {
    name: "Colson Whitehead",
    books: ["The Underground Railroad", "The Nickel Boys"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "colsonwhitehead.com"
  },
  {
    name: "Fonda Lee",
    books: ["Jade City"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      },
      {
        code: "CA",
        name: "Canada"
      },
      {
        code: "CN",
        name: "China"
      }
    ],
    website: "fondalee.com"
  },
  {
    name: "Axie Oh",
    books: ["The Girl Who Fell Beneath the Sea"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      },
      {
        code: "KR",
        name: "Korea"
      }
    ],
    website: "axieoh.com"
  },
  {
    name: "Sidik Fofana",
    books: ["Stories from the Tenants Downstairs"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "sidikfofana.com"
  },
  {
    name: "Krystal Marquis",
    books: ["The Davenports"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "krystalmarquis.com"
  },
  {
    name: "Akwaeke Emezi",
    books: ["Bitter", "The Death of Vivek Oji"],
    poc: true,
    gender: "non-binary", // change to array later
    lgbt: true,
    fav: false,
    country: [
      {
        code: "NG",
        name: "Nigeria"
      }
    ],
    website: "akwaeke.com"
  },
  {
    name: "Tommy Orange",
    books: ["There, There", "Wandering Stars"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "penguinrandomhouse.com/authors/2156371/tommy-orange/"
  },
  {
    name: "B.B. Alston",
    books: ["Amari and the Night Brothers"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "bbalston.com"
  },
  {
    name: "Meredith Katz",
    books: ["The Cybernetic Tea Shop"],
    poc: false,
    gender: "non-binary",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "CA",
        name: "Canada"
      }
    ],
    website: "softcryptid.com"
  },
  {
    name: "Ken Liu",
    books: ["The Hidden Girl and Other Stories"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      },
      {
        code: "CN",
        name: "China"
      }
    ],
    website: "kenliu.name"
  },
  {
    name: "Nella Larsen",
    books: ["Passing"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "en.wikipedia.org/wiki/Nella_Larsen"
  },
  {
    name: "Kanae Minato",
    books: ["Confessions", "Penance"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "JP",
        name: "Japan"
      }
    ],
    website: "en.wikipedia.org/wiki/Kanae_Minato"
  },
  {
    name: "Ling Ling Huang",
    books: ["Natural Beauty"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      },
      {
        code: "CN",
        name: "China"
      }
    ],
    website: "www.linglinghuang.com"
  },
  {
    name: "Honorée Fanonne Jeffers",
    books: ["The Love Songs of W.E.B. Du Bois"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "honoreejeffers.com"
  },
  {
    name: "Tracey Rose Peyton",
    books: ["Night Wherever We Go"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "traceyrosepeyton.com"
  },
  {
    name: "Erin E. Adams",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      },
      {
        code: "HT",
        name: "Haiti"
      }
    ],
    website: "erineadams.com"
  },
  {
    name: "Violet Allen",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: ""
  },
  {
    name: "Lesley Nneka Arimah",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "NG",
        name: "Nigeria"
      },
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "larimah.com"
  },
  {
    name: "Maurice Broaddus",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "mauricebroaddus.com"
  },
  {
    name: "Chesya Burke",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "thechesyaburke.org"
  },
  {
    name: "Ezra Claytan Daniels",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "ezracdaniels.com"
  },
  {
    name: "Tananarive Due",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "tananarivedue.com"
  },
  {
    name: "Nalo Hopkinson",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "JM",
        name: "Jamaica"
      },
      {
        code: "CA",
        name: "Canada"
      }
    ],
    website: "nalohopkinson.com"
  },
  {
    name: "Justin C. Key",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: ""
  },
  {
    name: "L.D. Lewis",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "ldlewiswrites.com"
  },
  {
    name: "Tochi Onyebuchi",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "tochionyebuchi.com"
  },
  {
    name: "Rebecca Roanhorse",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "rebeccaroanhorse.com"
  },
  {
    name: "Nicole D. Sconiers",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: ""
  },
  {
    name: "Rion Amilcar Scott",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "rionamilcarscott.com"
  },
  {
    name: "Terence Taylor",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: ""
  },
  {
    name: "Cadwell Turnbull",
    books: ["Out There Screaming: An Anthology of New Black Horror"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "cadwellturnbull.com"
  },
  {
    name: "Isabel Wilkerson",
    books: ["Caste: The Origins of Our Discontents"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "isabelwilkerson.com"
  },
  {
    name: "Megan Giddings",
    books: ["Lakewood"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "megangiddings.com"
  },
  {
    name: "Sohn Won-Pyung",
    books: ["Almond"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "KR",
        name: "Korea"
      }
    ],
    website: "en.wikipedia.org/wiki/Sohn_Won-pyung"
  },
  {
    name: "Jamila Rowser",
    books: ["Wash Day Diaries"],
    poc: true,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "PR",
        name: "Puerto Rico"
      },
      {
        code: "DO",
        name: "Dominican Republic"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "jamilarowser.com"
  },
  {
    name: "Robyn Smith",
    books: ["Wash Day Diaries"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "JM",
        name: "Jamaica"
      }
    ],
    website: "robrosmo.com"
  },
  {
    name: "Emma Newman",
    books: [
      "Planetfall",
      "After Atlas",
      "Before Mars",
      "Atlas Alone",
      "Before, After, Alone"
    ],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "enewman.co.uk"
  },
  {
    name: "Martha Wells",
    books: [
      "All Systems Red",
      "Artificial Condition",
      "Rogue Protocol",
      "Exit Strategy",
      "Network Effect",
      "Fugitive Telemetry",
      "System Collapse"
    ],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "marthawells.com"
  },
  {
    name: "Dolen Perkins-Valdez",
    books: ["Take My Hand"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "dolenperkinsvaldez.com"
  },
  {
    name: "Nana Kwame Adjei-Brenyah",
    books: ["Chain-Gang All-Stars"],
    poc: true,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      },
      {
        code: "GH",
        name: "Ghana"
      }
    ],
    website: "nanakwameadjei-brenyah.com"
  },
  {
    name: "James Islington",
    books: ["The Will of the Many"],
    poc: false,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "AU",
        name: "Australia"
      }
    ],
    website: "jamesislington.com"
  },
  {
    name: "Julia Alvarez",
    books: ["In the Time of the Butterflies"],
    poc: true,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "DO",
        name: "Dominican Republic"
      },
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "juliaalvarez.com"
  },
  {
    name: "Philippa Gregory",
    books: [
      "The Lady of the Rivers",
      "The White Queen",
      "The Red Queen",
      "The Kingmakers Daughter",
      "The White Princess",
      "The King's Curse",
      "The Other Boleyn Girl",
      "The Boleyn Inheritance",
      "The Taming of the Queen"
    ],
    poc: false,
    gender: "female",
    lgbt: false,
    fav: true,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "philippagregory.com"
  },
  {
    name: "Alice Oseman",
    books: ["Heartstopper: Volume One"],
    poc: false,
    gender: "female",
    lgbt: true,
    fav: false,
    country: [
      {
        code: "GB",
        name: "United Kingdom"
      }
    ],
    website: "aliceoseman.com"
  },
  {
    name: "Jonathan Larson",
    books: ["Tick, Tick... Boom!"],
    poc: false,
    gender: "male",
    lgbt: false,
    fav: false,
    country: [
      {
        code: "US",
        name: "United States"
      }
    ],
    website: "en.wikipedia.org/wiki/Jonathan_Larson"
  }
];
